/**
 * Matches X403 errors from ESB
 */
export function isUnAuthorizedError(params: {
  errorMessage: string;
  errorCode: string;
}) {
  if (params.errorCode?.match(/^.403/)) return true;

  return false;
}
